module.exports = __webpack_public_path__ + "media/images/undraw/shift/visionary_technology-757d3335df8236691e297fd9a7f3cfaf.png";